<template>
    <div class="box">
        <span class="version">version:{{ network.version }} device:{{ network.deviceId }}</span>
        <div class="purchase_box">
            <div class="leftBox">
                <div class="col">
                    <div class="top">
                        <img style="width:13vw;height:7.8vh;margin: 2vh 0 0 "
                            src="@/assets/visualization/materialPreparation.svg" />
                        <div class="splitline"></div>
                        <div>
                            <span>{{ pick.count }}</span>
                            <span>笔</span>
                        </div>
                        <!-- <div>备料作业</div> -->
                    </div>
                    <div class="bottom">
                        <div id="title">备料</div>
                    </div>
                </div>
            </div>
            <div class="rightBox">
                <div class="col">
                    <div class="top">
                        <div class="overdue">逾期</div>
                        <div class="firstBox">
                            <span>{{ pick.overdue && pick.overdue.count }}</span>
                            <span>笔</span>
                        </div>
                        <div class="secondBox">
                            <!-- <img src="@/assets/visualization/bs.svg" /> -->
                            <div class="secondBox-text">
                                <span>{{ pick.overdue && pick.overdue.typeQuantity }}</span>
                                <span>SKU</span>
                            </div>
                        </div>
                        <div class="thirdBox">
                            <div>
                                <span>{{ formatNumber(pick.overdue.quantity) }} </span>
                                <span> PCS</span>
                            </div>
                        </div>
                    </div>
                    <div class="splitline"></div>
                    <div class="bottom">
                        <div>
                            <div class="red-check-circle"></div>
                            <div>
                                <span>{{ pick.overdue_complete && pick.overdue_complete.count }}</span>
                                <span>笔</span>
                            </div>
                        </div>
                        <div>
                            <span> {{ pick.overdue_complete && pick.overdue_complete.typeQuantity }}</span>
                            <span>SKU</span>
                        </div>
                        <div>
                            <span>{{ pick.overdue_complete && Math.round(pick.overdue_complete.quantity) }} </span>
                            <span> PCS</span>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="top">
                        <div class="overdue">本周</div>
                        <div class="firstBox">
                            <span>{{ pick.this_week && pick.this_week.count }}</span>
                            <span>笔</span>
                        </div>
                        <div class="secondBox">
                            <!-- <img src="@/assets/visualization/bs.svg" /> -->
                            <div class="secondBox-text">
                                <span>{{ pick.this_week && pick.this_week.typeQuantity }}</span>
                                <span>SKU</span>
                            </div>
                        </div>
                        <div class="thirdBox">
                            <div>
                                <span>{{ formatNumber(pick.this_week.quantity) }} </span>
                                <span> PCS</span>
                            </div>
                        </div>
                    </div>
                    <div class="splitline"></div>
                    <div class="bottom">
                        <div>
                            <div class="blue-check-circle"></div>
                            <div class="blue">
                                <span>{{ pick.this_week_complete && pick.this_week_complete.count }}</span>
                                <span>笔</span>
                            </div>
                        </div>
                        <div>
                            <span>{{ pick.this_week_complete && pick.this_week_complete.typeQuantity }}</span>
                            <span>SKU</span>
                        </div>
                        <div>
                            <span>{{ pick.this_week_complete && Math.round(pick.this_week_complete.quantity) }}</span>
                            <span> PCS</span>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="top">
                        <div class="overdue">下周</div>
                        <div class="firstBox">
                            <span>{{ pick.next_week && pick.next_week.count }}</span>
                            <span>笔</span>
                        </div>
                        <div class="secondBox">
                            <!-- <img src="@/assets/visualization/bs.svg" /> -->
                            <div class="secondBox-text">
                                <span>{{ pick.next_week && pick.next_week.typeQuantity }}</span>
                                <span>SKU</span>
                            </div>
                        </div>
                        <div class="thirdBox">
                            <div>
                                <span>{{ formatNumber(pick.next_week.quantity) }} </span>
                                <span> PCS</span>
                            </div>
                        </div>
                    </div>
                    <div class="splitline"></div>
                    <div class="bottom">
                        <div>
                            <div class="green-check-circle"></div>
                            <div>
                                <span>{{ pick.next_week_complete && pick.next_week_complete.count }}</span>
                                <span>笔</span>
                            </div>
                        </div>
                        <div>
                            <span>{{ pick.next_week_complete && pick.next_week_complete.typeQuantity }}</span>
                            <span>SKU</span>
                        </div>
                        <div>
                            <span>{{ pick.next_week_complete && Math.round(pick.next_week_complete.quantity) }}</span>
                            <span> PCS</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="purchase_box">
            <div class="leftBox">
                <div class="col">
                    <div class="top">
                        <img style="width:10vh;height:auto;margin:2vh 0 0  "
                            src="@/assets/visualization/materialRequisition.svg" />
                        <div class="splitline"></div>
                        <div>
                            <span>{{ requisition.count }}</span>
                            <span>笔</span>
                        </div>
                        <!-- <div>领料作业</div> -->
                    </div>
                    <div class="bottom">
                        <div id="title">领料</div>
                        <!-- <div>待领料/已领料</div> -->
                    </div>
                </div>
            </div>
            <div class="rightBox">
                <div class="col">
                    <div class="top">
                        <div class="overdue">逾期</div>
                        <div class="firstBox red">
                            <span>{{ requisition.overdue && requisition.overdue.count }}</span>
                            <span>笔</span>
                        </div>
                        <div class="secondBox">
                            <!-- <img src="@/assets/visualization/bs.svg" /> -->
                            <div class="secondBox-text">
                                <span>{{ requisition.overdue && requisition.overdue.typeQuantity }}</span>
                                <span>SKU</span>
                            </div>
                        </div>
                        <div class="thirdBox">
                            <div>
                                <span>{{ formatNumber(requisition.overdue.quantity) }} </span>
                                <span> PCS</span>
                            </div>
                        </div>
                    </div>
                    <div class="splitline"></div>
                    <div class="bottom">
                        <div>
                            <div class="red-check-circle"></div>
                            <div class="red">
                                <span>{{ requisition.overdue_complete && requisition.overdue_complete.count }}</span>
                                <span>笔</span>
                            </div>
                        </div>
                        <div>
                            <span>{{ requisition.overdue_complete && requisition.overdue_complete.typeQuantity }}</span>
                            <span>SKU</span>
                        </div>
                        <div>
                            <span>{{ requisition.overdue_complete && Math.round(requisition.overdue_complete.quantity)
                                }}
                            </span>
                            <span> PCS</span>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="top">
                        <div class="overdue">本周</div>
                        <div class="firstBox blue">
                            <span>{{ requisition.this_week && requisition.this_week.count }}</span>
                            <span>笔</span>
                        </div>
                        <div class="secondBox">
                            <!-- <img src="@/assets/visualization/bs.svg" /> -->
                            <div class="secondBox-text">
                                <span>{{ requisition.this_week && requisition.this_week.typeQuantity }}</span>
                                <span>SKU</span>
                            </div>
                        </div>
                        <div class="thirdBox">
                            <div>
                                <span>{{ formatNumber(requisition.this_week.quantity) }}</span>
                                <span> PCS</span>
                            </div>
                        </div>
                    </div>
                    <div class="splitline"></div>
                    <div class="bottom">
                        <div>
                            <div class="blue-check-circle"></div>
                            <div class="blue">
                                <span>{{ requisition.this_week_complete && requisition.this_week_complete.count
                                    }}</span>
                                <span>笔</span>
                            </div>
                        </div>
                        <div>
                            <span>{{ requisition.this_week_complete && requisition.this_week_complete.typeQuantity
                                }}</span>
                            <span>SKU</span>
                        </div>
                        <div>
                            <span>{{ requisition.this_week_complete &&
                                Math.round(requisition.this_week_complete.quantity)
                                }}</span>
                            <span> PCS</span>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="top">
                        <div class="overdue">下周</div>
                        <div class="firstBox">
                            <span>{{ requisition.next_week && requisition.next_week.count }}</span>
                            <span>笔</span>
                        </div>
                        <div class="secondBox">
                            <!-- <img src="@/assets/visualization/bs.svg" /> -->
                            <div class="secondBox-text">
                                <span>{{ requisition.next_week && requisition.next_week.typeQuantity }}</span>
                                <span>SKU</span>
                            </div>
                        </div>
                        <div class="thirdBox">
                            <div>
                                <span>{{ formatNumber(requisition.next_week.quantity) }} </span>
                                <span> PCS</span>
                            </div>
                        </div>
                    </div>
                    <div class="splitline"></div>
                    <div class="bottom">
                        <div>
                            <div class="green-check-circle"></div>
                            <div class="green">
                                <span>{{ requisition.next_week_complete && requisition.next_week_complete.count
                                    }}</span>
                                <span>笔</span>
                            </div>
                        </div>
                        <div>
                            <span>{{ requisition.next_week_complete && requisition.next_week_complete.typeQuantity
                                }}</span>
                            <span>SKU</span>
                        </div>
                        <div>
                            <span>{{ requisition.next_week_complete &&
                                Math.round(requisition.next_week_complete.quantity)
                                }}
                            </span>
                            <span> PCS</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="purchase_box">
            <div class="leftBox">
                <div class="col">
                    <div class="top">
                        <img style="width:9.78vh;height:auto;margin:2vh 0 0 "
                            src="@/assets/visualization/delivery.svg" />
                        <div class="splitline"></div>
                        <div>
                            <span>{{ delivery.count }}</span>
                            <span>笔</span>
                        </div>
                        <!-- <div>交付作业</div> -->
                    </div>
                    <div class="bottom">
                        <div id="title">交付</div>
                        <!-- <div>待交付/已交付</div> -->
                    </div>
                </div>
            </div>
            <div class="rightBox">
                <div class="col">
                    <div class="top">
                        <div class="overdue">逾期</div>
                        <div class="firstBox red">
                            <span>{{ delivery.overdue && delivery.overdue.count }}</span>
                            <span>笔</span>
                        </div>
                        <div class="secondBox">
                            <!-- <img src="@/assets/visualization/bs.svg" /> -->
                            <div class="secondBox-text">
                                <span>{{ delivery.overdue && delivery.overdue.typeQuantity }}</span>
                                <span>SKU</span>
                            </div>
                        </div>
                        <div class="thirdBox">
                            <div>
                                <span>{{ formatNumber(delivery.overdue.quantity) }} </span>
                                <span> PCS</span>
                            </div>
                        </div>
                    </div>
                    <div class="splitline"></div>
                    <div class="bottom">
                        <div>
                            <div class="red-check-circle"></div>
                            <div>
                                <span>{{ delivery.overdue_complete && delivery.overdue_complete.count }}</span>
                                <span>笔</span>
                            </div>
                        </div>
                        <div>
                            <span>{{ delivery.overdue_complete && delivery.overdue_complete.typeQuantity }}</span>
                            <span>SKU</span>
                        </div>
                        <div>
                            <span>{{ delivery.overdue_complete && Math.round(delivery.overdue_complete.quantity)
                                }}</span>
                            <span> PCS</span>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="top">
                        <div class="overdue">本周</div>
                        <div class="firstBox">
                            <span>{{ delivery.this_week && delivery.this_week.count }}</span>
                            <span>笔</span>
                        </div>
                        <div class="secondBox">
                            <!-- <img src="@/assets/visualization/bs.svg" /> -->
                            <div class="secondBox-text">
                                <span>{{ delivery.this_week && delivery.this_week.typeQuantity }}</span>
                                <span>SKU</span>
                            </div>
                        </div>
                        <div class="thirdBox">
                            <div>
                                <span>{{ formatNumber(delivery.this_week.quantity) }} </span>
                                <span> PCS</span>
                            </div>
                        </div>
                    </div>
                    <div class="splitline"></div>
                    <div class="bottom">
                        <div>
                            <div class="blue-check-circle"></div>
                            <div>
                                <span>{{ delivery.this_week_complete && delivery.this_week_complete.count }}</span>
                                <span>笔</span>
                            </div>
                        </div>
                        <div>
                            <span>{{ delivery.this_week_complete && delivery.this_week_complete.typeQuantity }}</span>
                            <span>SKU</span>
                        </div>
                        <div>
                            <span>{{ delivery.this_week_complete && Math.round(delivery.this_week_complete.quantity) }}
                            </span>
                            <span> PCS</span>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="top">
                        <div class="overdue">下周</div>
                        <div class="firstBox">
                            <span>{{ delivery.next_week && delivery.next_week.count }}</span>
                            <span>笔</span>
                        </div>
                        <div class="secondBox">
                            <!-- <img src="@/assets/visualization/bs.svg" /> -->
                            <div class="secondBox-text">
                                <span>{{ delivery.next_week && delivery.next_week.typeQuantity }}</span>
                                <span>SKU</span>
                            </div>
                        </div>
                        <div class="thirdBox">
                            <div>
                                <span>{{ formatNumber(delivery.next_week.quantity) }} </span>
                                <span> PCS</span>
                            </div>
                        </div>
                    </div>
                    <div class="splitline"></div>
                    <div class="bottom">
                        <div>
                            <div class="green-check-circle"></div>
                            <div>
                                <span>{{ delivery.next_week_complete && delivery.next_week_complete.count }}</span>
                                <span>笔</span>
                            </div>
                        </div>
                        <div>
                            <span>{{ delivery.next_week_complete && delivery.next_week_complete.typeQuantity }}</span>
                            <span>SKU</span>
                        </div>
                        <div>
                            <span>{{ delivery.next_week_complete && Math.round(delivery.next_week_complete.quantity) }}
                            </span>
                            <span> PCS</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <div>
                <span style="font-size: 26px;">{{ dateweek.day }} {{ dateweek.week }}</span>
                <span class="mock-block">
                    <img class="icon" src="@/assets/visualization/calendar.svg" />
                </span>
            </div>
            <div>
                <span style="font-size: 20px;color: red;" v-if="network.msg">{{network.msg}}</span>
            </div>
            <div>
                <span style="font-size: 26px;">{{ dateweek.time }}</span>
                <span class="mock-block">
                    <img class="icon" src="@/assets/visualization/time.svg" />
                </span>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    props: {
        dateweek: {
            type: Object
        },
        network: {
            type: Object
        },
        payload: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            pick: {
                count: '',
                overdue: {},
                overdue_complete: {},
                this_week: {},
                this_week_complete: {},
                next_week: {},
                next_week_complete: {},
            },
            requisition: {
                count: '',
                overdue: {},
                overdue_complete: {},
                this_week: {},
                this_week_complete: {},
                next_week: {},
                next_week_complete: {},
            },
            delivery: {
                count: '',
                overdue: {},
                overdue_complete: {},
                this_week: {},
                this_week_complete: {},
                next_week: {},
                next_week_complete: {},
            },
            updateTimer: null,
        }
    },
    watch: {
        payload() {
            this.setpayload()
        }
    },
    created() {
        this.setpayload()
    },
    // 挂载时间
    methods: {
        setpayload() {
            this.payload.forEach(item => {
                // 备料需求
                if (item.requireType && item.requireType.value == 'PICK') {
                    let pickArr = item.items
                    this.pick.count = 0
                    pickArr.forEach((item) => {
                        //逾期未完成
                        if (item.dataType.value == 'OVERDUE') {
                            this.pick.overdue = item
                        }
                        // 逾期本周已完成
                        if (item.dataType.value == "OVERDUE_COMPLETE") {
                            this.pick.overdue_complete = item
                        }
                        // 本周未完成
                        if (item.dataType.value == "THIS_WEEK") {
                            this.pick.this_week = item
                        }
                        // 本周完成
                        if (item.dataType.value == "THIS_WEEK_COMPLETE") {
                            this.pick.this_week_complete = item
                        }
                        // 下周未完成
                        if (item.dataType.value == "NEXT_WEEK") {
                            this.pick.next_week = item
                        }
                        // 下周已完成
                        if (item.dataType.value == "NEXT_WEEK_COMPLETE") {
                            this.pick.next_week_complete = item
                        }
                        this.pick.count += item.count
                    })
                }
                // 领料需求
                if (item.requireType && item.requireType.value == 'REQUISITION') {
                    let requisitionArr = item.items
                    this.requisition.count = 0
                    requisitionArr.forEach((item) => {
                        //逾期未完成
                        if (item.dataType.value == 'OVERDUE') {
                            this.requisition.overdue = item
                        }
                        // 逾期本周已完成
                        if (item.dataType.value == "OVERDUE_COMPLETE") {
                            this.requisition.overdue_complete = item
                        }
                        // 本周未完成
                        if (item.dataType.value == "THIS_WEEK") {
                            this.requisition.this_week = item
                        }
                        // 本周完成
                        if (item.dataType.value == "THIS_WEEK_COMPLETE") {
                            this.requisition.this_week_complete = item
                        }
                        // 下周未完成
                        if (item.dataType.value == "NEXT_WEEK") {
                            this.requisition.next_week = item
                        }
                        // 下周已完成
                        if (item.dataType.value == "NEXT_WEEK_COMPLETE") {
                            this.requisition.next_week_complete = item
                        }
                        this.requisition.count += item.count
                    })
                }
                // 交付作业
                if (item.requireType && item.requireType.value == 'DELIVERY') {
                    let deliveryArr = item.items
                    this.delivery.count = 0
                    deliveryArr.forEach((item) => {
                        //逾期未完成
                        if (item.dataType.value == 'OVERDUE') {
                            this.delivery.overdue = item
                        }
                        // 逾期本周已完成
                        if (item.dataType.value == "OVERDUE_COMPLETE") {
                            this.delivery.overdue_complete = item
                        }
                        // 本周未完成
                        if (item.dataType.value == "THIS_WEEK") {
                            this.delivery.this_week = item
                        }
                        // 本周完成
                        if (item.dataType.value == "THIS_WEEK_COMPLETE") {
                            this.delivery.this_week_complete = item
                        }
                        // 下周未完成
                        if (item.dataType.value == "NEXT_WEEK") {
                            this.delivery.next_week = item
                        }
                        // 下周已完成
                        if (item.dataType.value == "NEXT_WEEK_COMPLETE") {
                            this.delivery.next_week_complete = item
                        }
                        this.delivery.count += item.count
                    })

                }

            });
        },
        // 将数字转换w,kw单位
        formatNumber(number) {
            let num = number ? Math.round(number) : 0
            let result = ''
            if (num.toString().length > 5 && num.toString().length < 7) {
                result = (num / 1e4).toFixed(1) + 'w';
            } else if (num.toString().length >= 7) {
                result = (num / 1e7).toFixed(1) + 'kw';
            } else {
                result = num
            }
            return result
        },

    },
    beforeCreate() {
        document.getElementsByTagName('body')[0].style.margin = '0'
    },
}
</script>

<style scoped lang="less">
* {
    margin: 0;
    padding: 0;
}

.box {
    padding: 45px 0 0;
    background: white;
    //   width: calc(100vw - 10px);
    width: 100%;
    height: calc(100vh - 45px);
    overflow: hidden;

    .purchase_box {
        margin: 0 50px 30px;
        height: calc(32vh - 58px);
        // margin-bottom: 50px;
        display: flex;
        border-radius: 10px;
        border: 5px solid #333333;

        .leftBox {
            width: 25%;
            border-radius: 6px 0 0 6px;
            text-align: center;
            border-right: 5px solid #333;
            box-sizing: border-box;

            .col {
                font-size: 2vh;

                .top {
                    height: calc(22.4vh - 12px - 50px);
                    margin-bottom: 2.2vh;

                    div {
                        span:nth-child(1) {
                            font-size: 4vh;
                        }
                    }

                    img {
                        vertical-align: middle // width: 8vw;
                            // height: 8vh;
                    }

                    .splitline {
                        width: auto;
                        height: 5px;
                        margin: 2.5vh 22px 2.2vh;
                        background-color: #333;

                    }
                }

                .bottom {
                    height: 7.8vh;
                    color: #FFFFFF;
                    background: #333;
                    border-radius: 0 0 0 5px;

                    div:first-child {
                        font-size: 5vh;
                        line-height: 7.8vh;
                    }

                    div:nth-child(2) {
                        font-size: 2vh;
                        line-height: 4.6vh;
                    }
                }
            }
        }

        .rightBox {
            width: 75%;
            display: flex;

            .col:nth-child(1),
            .col:nth-child(2),
            .col:nth-child(3) {
                color: #333;
                flex: 1;

                .top {
                    height: calc(21.4vh - 8px - 50px);
                    border-radius: 6px;
                    // padding: 0.5vh 30px;

                    .overdue {
                        color: #fff;
                        height: 4.17vh;
                        line-height: 4.17vh;
                        font-size: 2vh;
                        // padding-bottom: 20px;
                        // border-bottom: 1px solid rgba(255, 255, 255, 0.2);
                    }

                    .firstBox {
                        // background: rgba(255, 255, 255, 0.3);
                        border-radius: 6px;
                        text-align: right;
                        padding-right: 20px;
                        margin-top: 1.5vh;
                        // height: 58px;
                        height: 4vh;

                        span {
                            // font-size: 50px;
                            // line-height: 1;
                            font-size: 4vh;
                            line-height: 4vh;
                        }

                        span:nth-child(2) {
                            font-size: 2vh // font-size: 26px;
                                // line-height: 1;
                        }

                    }

                    .secondBox {
                        // background: rgba(255, 255, 255, 0.3);
                        border-radius: 6px;
                        // margin-top: 1vh;
                        // padding: 0px 12px 5px 12px;
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        padding: 0px 20px;

                        // img {
                        //     width: 2vh;
                        //     height: 2vh,
                        // }

                        .secondBox-text {
                            // display: inline-block;
                            // float: right;
                            // font-size: 30px;
                            font-size: 3vh;

                            span:nth-child(2) {
                                font-size: 1.5vh
                            }
                        }
                    }

                    .thirdBox {
                        // margin-top: 1vh;
                        // background: rgba(255, 255, 255, 0.3);
                        border-radius: 6px;
                        padding-right: 20px;
                        // font-size: 30px;

                        text-align: right;

                        div {
                            span:first-child {
                                font-size: 2.4vh;
                            }

                            span:nth-child(2) {
                                font-size: 1.5vh;
                            }
                        }
                    }
                }

                .splitline {
                    width: auto;
                    height: 2px;
                    margin: 0 18px 2vh;
                    background-color: #333;
                }

                .bottom {
                    // height: 9.6vh;
                    // height: calc(9.6vh - 2px);
                    color: #333;
                    border-radius: 6px;
                    padding: 0px 20px 0 40px;
                    line-height: 2.1vh;

                    div:nth-child(1) {
                        display: flex;
                        justify-content: space-between;
                        // align-items: center;
                        // font-size: 2.5vh;
                        // line-height: 4.6vh;

                        img {
                            width: 2vw;
                            height: 2vh,
                        }

                        div {
                            span:first-child {
                                font-size: 2.5vh;
                            }

                            span:nth-child(2) {
                                font-size: 1.5vh;
                            }
                        }
                    }

                    div:nth-child(2) {
                        font-size: 2vh;

                        span:nth-child(2) {
                            font-size: 1.2vh;
                        }
                    }

                    div:nth-child(3) {
                        span:first-child {
                            font-size: 1.5vh;
                        }

                        span:nth-child(2) {
                            font-size: 1vh;
                        }
                    }

                    div:nth-child(2),
                    div:nth-child(3) {
                        text-align: right;
                    }

                }

            }

            .col {
                width: calc((100vw - 25vw - 40px) / 3 - 15px);
            }

            .col:not(:last-child) {
                border-right: 5px solid #333;
            }

            .col:nth-child(1) .top {

                // background: #F56C6C;
                .overdue {
                    background-color: #FA5151;
                }
            }

            .col:nth-child(2) .top {

                // background: #1890FF;
                .overdue {
                    background-color: #1890FF;
                }
            }

            .col:nth-child(3) .top {

                // background: #52C41A;
                .overdue {
                    background-color: #00B578;
                    border-radius: 0 5px 0 0;
                }
            }

            .col:nth-child(3) .bottom {
                // color: #52C41A;
            }

            .col:nth-child(2) .bottom {}

            .col:nth-child(1) .bottom {
                // color: #F56C6C;
            }
        }
    }

    .purchase_box:nth-child(3) {
        margin-bottom: 35px;
    }

    .secondBox {
        // background: rgba(255, 255, 255, 0.3);
        border-radius: 6px;
        margin-top: 1vh;


    }

    .footer {
        height: 4vh;
        background: #D0E9FF;
        padding: 2px 40px 2px 20px;
        color: #333;
        display: flex;
        justify-content: space-between;
        align-items: center;

        div {
            display: flex;
            align-items: center;

            .icon {
                width: 30px;
                height: auto;
                vertical-align: middle;
                margin: 0 0 0 20px;
            }
        }
    }

    .red {
        color: #FA5151;
    }

    .blue {
        color: #1890FF;
    }

    .green {
        color: #00B578;
    }

    .red-check-circle {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: rgba(250, 81, 81, 0.7);
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .red-check-circle::before {
        content: "";
        display: block;
        width: 14px;
        height: 8px;
        border: 3px solid #fff;
        border-right: none;
        border-top: none;
        transform: rotate(-45deg) translate(6px, 3px);
    }

    .blue-check-circle {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: rgba(24, 144, 255, 0.7);
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .blue-check-circle::before {
        content: "";
        display: block;
        width: 14px;
        height: 8px;
        border: 3px solid #fff;
        border-right: none;
        border-top: none;
        transform: rotate(-45deg) translate(6px, 3px);
    }

    .green-check-circle {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: rgba(0, 181, 120, 0.7);
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .green-check-circle::before {
        content: "";
        display: block;
        width: 14px;
        height: 8px;
        border: 3px solid #fff;
        border-right: none;
        border-top: none;
        transform: rotate(-45deg) translate(6px, 3px);
    }
}

.version{
    font-size:20px;
    position: absolute;
    left: 0px;
    top: 10px;
    color:rgba(0, 0, 0, 0.3)
}
</style>



// WEBPACK FOOTER //
// src/views/warehouse/Outgoing.vue